import { throttle } from '../../utils';

const Map = async () => {
  const component = document.querySelector('.js-map-map');
  const lng = component ? parseFloat(component.dataset.lng) : null;
  const lat = component ? parseFloat(component.dataset.lat) : null;
  const name = component ? component.dataset.name : null;

  if (component && lat && lng) {
    let map;
    let currentLng;
    let lngLg;
    let lngMd;
    let lngXs;

    const { Map } = await window.google.maps.importLibrary('maps');
    const { AdvancedMarkerElement } = await window.google.maps.importLibrary('marker');

    const getMapOptions = (lat, lng) => {
      return {
        center: {
          lat,
          lng,
        },
        clickableIcons: false,
        disableDefaultUI: true,
        gestureHandling: 'none',
        keyboardShortcuts: false,
        mapId: 'dealer-map',
        zoom: 18,
      };
    };

    const getMapStyle = () => {
      const mapStyle = [
        {
          featureType: 'administrative',
          elementType: 'all',
          stylers: [
            {
              saturation: '-100',
            },
          ],
        },
        {
          featureType: 'administrative.province',
          elementType: 'all',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'landscape',
          elementType: 'all',
          stylers: [
            {
              saturation: -100,
            },
            {
              lightness: 65,
            },
            {
              visibility: 'on',
            },
          ],
        },
        {
          featureType: 'poi',
          elementType: 'all',
          stylers: [
            {
              saturation: -100,
            },
            {
              lightness: '50',
            },
            {
              visibility: 'simplified',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'all',
          stylers: [
            {
              saturation: '-100',
            },
          ],
        },
        {
          featureType: 'road.highway',
          elementType: 'all',
          stylers: [
            {
              visibility: 'simplified',
            },
          ],
        },
        {
          featureType: 'road.arterial',
          elementType: 'all',
          stylers: [
            {
              lightness: '30',
            },
          ],
        },
        {
          featureType: 'road.local',
          elementType: 'all',
          stylers: [
            {
              lightness: '40',
            },
          ],
        },
        {
          featureType: 'transit',
          elementType: 'all',
          stylers: [
            {
              saturation: -100,
            },
            {
              visibility: 'simplified',
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [
            {
              hue: '#ffff00',
            },
            {
              lightness: -25,
            },
            {
              saturation: -97,
            },
          ],
        },
        {
          featureType: 'water',
          elementType: 'labels',
          stylers: [
            {
              lightness: -25,
            },
            {
              saturation: -100,
            },
          ],
        },
      ];

      return new window.google.maps.StyledMapType(
        mapStyle,
        {
          name: 'Styled Map',
        });
    };

    const handleResize = (map, lat) => {
      const W = window.innerWidth;

      if (W <= 900 && currentLng !== lngXs) {
        currentLng = lngXs;
        map.setCenter({ lat, lng: currentLng });
      }

      if (W > 900 && W <= 1200 && currentLng !== lngMd) {
        currentLng = lngMd;
        map.setCenter({ lat, lng: currentLng });
      }

      if (W > 1200 && currentLng !== lngLg) {
        currentLng = lngLg;
        map.setCenter({ lat, lng: currentLng });
      }
    };

    const initMap = async () => {
      const dealerName = component.closest('.js-map').querySelector('.js-map-dealer');
      const markerWrapper = document.createElement('div');

      map = new Map(component, getMapOptions(lat, lng));

      if (map && AdvancedMarkerElement) {
        const mapMarker = new AdvancedMarkerElement({
          map,
          position: {
            lat,
            lng,
          },
        });
        const textMarker = new AdvancedMarkerElement({
          map,
          position: {
            lat,
            lng,
          },
        });

        currentLng = lng;
        lngLg = lng + 0.001;
        lngMd = lng + 0.0012;
        lngXs = lng + 0.0002;

        markerWrapper.className = 'o-map__marker';
        markerWrapper.append(dealerName);
        textMarker.append(markerWrapper);

        map.mapTypes.set('styled_map', getMapStyle());
        map.setMapTypeId('styled_map');

        const throttledResize = throttle(() => handleResize(map, lat), 100);

        window.addEventListener('resize', throttledResize);

        handleResize(map, lat);
      }
    };

    initMap();
  }
};

export default Map;
